module.exports = {
    edit: 'Edit',
    activate: 'Activate',
    deactivate: 'Deactivate',
    cancel: 'Cancel',
    create: 'Create',
    update: 'Update',
    submit: 'Submit',
    clear: 'Clear',
    selectTime: 'Select time',
    save: 'Save',
    open: 'Open',
    show: 'Show',
    select: 'Select',
    back: 'Back',
    download: 'Download',
    cancellation: 'Cancel',
    print: 'Print',
    yes: 'Yes',
    no: 'No',
    success: 'Success',
    view: 'View',
    clearBasket: 'Clear',
    refreshBtn: 'Refresh',
    reload: 'Reload',
    selectAll: 'Select All',
    selectNone: 'Select None',
    loading: 'Loading...',
    downloadPdf: 'Download PDF',
    add: 'Add',
    exportClientsList: 'Export clients list',
    createClient: 'Create client',
    createUser: 'Create user',
    deleteUser: 'Are you sure you want to delete this user?',
    onceDeleteWarning: 'Once you delete',
    fromDeleteWarning: 'from the list, the data will be permanently lost.',
    addUser: 'Add user',
    uploadImage: 'Upload image',
    dropImage: 'Drop your image here',
    orClick: 'or click',
    saveChanges: 'Save changes',
    reset: 'Reset',
    deleteClient: 'Are you sure you want to delete this client?',
    createLocation: 'Create location',
    exportLocations: 'Export locations list',
    addAnotherLocation: 'Add another entrance',
    exportCompanies: 'Export companies list',
    createCompany: 'Create company',
    deleteCompany: 'Are you sure you want to delete this company?',
    deleteEmployee: 'Are you sure you want to delete this employee?',
    exportEmployees: 'Export employees list',
    createEmployee: 'Create employee',
    importEmployees: 'Import employees',
    exportDevices: 'Export devices list',
    createDevice: 'Create Device',
    deleteDevice: 'Are you sure you want to delete this device?',
    importInvites: 'Import invites',
    createInvite: 'Create invite',
    createVisitor: 'Create visitor',
    deleteInvite: 'Are you sure you want to delete this invite?',
    deleteVisitor: 'Are you sure you want to delete this visitor?',
    viewAllClients: 'View all clients',
    viewWorkplaces: 'View Workplaces',
    viewGuests: 'View Guests',
    today: 'Today',
    thisWeek: 'This week',
    evacAlaram: 'Create alarm for evacuation',
    addToWoo: 'Add to Woo.',
    transferToS3: 'Transfer to PIM',
    deleteFromWoo: 'Delete from Woo',
    deleteFromS3: 'Delete from PIM',
    addToSite: 'Add to site',
    delete: 'Delete',
    selectPropertiesToCopy: 'Select properties to copy',
    copyProductProperties: 'Copy product properties',
};
